import { render, staticRenderFns } from "./com.vue?vue&type=template&id=912cbcd0&scoped=true&"
import script from "./com.vue?vue&type=script&lang=js&"
export * from "./com.vue?vue&type=script&lang=js&"
import style0 from "./com.vue?vue&type=style&index=0&id=912cbcd0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "912cbcd0",
  null
  
)

export default component.exports